import {ResolveFn} from '@angular/router';
import {inject} from "@angular/core";
import {GeneralLedgerService} from "../../general-ledger/service/general-ledger.service";
import {firstValueFrom} from "rxjs";
import {PayService} from "../../shared/service/pay/pay.service";
import {TramsDataSourceService} from "../../payments/service/trams-data-source.service";

export const financeResolver: ResolveFn<Promise<any>> = (_route, _state) => {
  const generalLedgerService = inject(GeneralLedgerService);
  const payService = inject(PayService);
  const tramsDataSourceService = inject(TramsDataSourceService);

  const travelType = firstValueFrom(generalLedgerService.getTravelTypeList());
  const submitTo = firstValueFrom(payService.getSubmitTo());
  const trams = firstValueFrom(tramsDataSourceService.getTramsDataSourceList());
  const branches = firstValueFrom(payService.getBranches());

  return Promise.all([travelType, submitTo, trams, branches]);
};
